let state = {
  quickLinksNewDashboard: [],
  bbpsImages: [],
  serviceType: undefined
};
export default state;



// WEBPACK FOOTER //
// ./src/store/quickLinksNewDashboard/state.js